import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Search, X } from "lucide-react";
import { CONTENT_TYPES_META } from "@/lib/constants";

export function SearchBar({ onClose }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => { ref.current?.focus(); }, []);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.get(`/search`, { params: { q } });
        setResults(res.data);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  const go = (item) => {
    const base = CONTENT_TYPES_META[item.type]?.route || "";
    navigate(`${base}/${item.slug}`);
    onClose?.();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-start justify-center pt-24 px-4" onClick={onClose} data-testid="search-overlay">
      <div className="w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 px-5 py-4 border-b border-vs-text/10">
          <Search className="w-5 h-5 text-vs-green" strokeWidth={1.5} />
          <input
            ref={ref}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cerca itinerari, guide, articoli, budget..."
            className="flex-1 outline-none text-lg bg-transparent"
            data-testid="search-input"
          />
          <button onClick={onClose} data-testid="search-close"><X className="w-5 h-5 text-vs-text/50" /></button>
        </div>
        <div className="max-h-[50vh] overflow-y-auto">
          {loading && <div className="p-6 text-vs-text/50">Ricerca in corso...</div>}
          {!loading && q.trim().length >= 2 && results.length === 0 && (
            <div className="p-6 text-vs-text/50">Nessun risultato per "{q}".</div>
          )}
          {results.map((r) => (
            <button
              key={r.id}
              onClick={() => go(r)}
              className="w-full text-left px-5 py-4 hover:bg-vs-bg flex items-center gap-4 border-b border-vs-text/5"
              data-testid="search-result-item"
            >
              <span className="text-xs uppercase tracking-wider font-bold text-vs-orange w-24 shrink-0">
                {CONTENT_TYPES_META[r.type]?.singular || r.type}
              </span>
              <span className="font-bold text-vs-text">{r.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
